module.exports = __webpack_public_path__ + "img/iconfont.1d4f8e3b.svg";